export class TreasuryPaymentIntentResponseContractError extends Error {
  constructor(operation, detail) {
    super(`Invalid Treasury payment-intent ${operation} response: ${detail}`);
    this.name = 'TreasuryPaymentIntentResponseContractError';
    this.code = 'INVALID_API_RESPONSE';
  }
}

const isRecord = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const text = value => typeof value === 'string' && value.length > 0;
const nullableText = value => value === null || typeof value === 'string';
const date = value => value === null || value instanceof Date && Number.isFinite(value.getTime())
  || typeof value === 'string' && Number.isFinite(Date.parse(value));
const requiredDate = value => value instanceof Date && Number.isFinite(value.getTime())
  || typeof value === 'string' && Number.isFinite(Date.parse(value));
const nullableAmount = value => value === null || Number.isFinite(value) && value >= 0;
const statuses = ['draft', 'awaiting_payment', 'submitted', 'observed', 'verified', 'failed', 'expired', 'mismatched', 'cancelled'];

const safe = value => !['password', 'passwordHash', 'accessToken', 'refreshToken', 'resetPasswordToken', 'emailVerificationCode'].some(key => Object.hasOwn(value, key));
const isPaymentIntent = intent => isRecord(intent) && safe(intent)
  && ['id', 'communityId', 'fundId', 'memberId', 'chain', 'tokenSymbol', 'reference'].every(key => text(intent[key]))
  && ['fundName', 'fundCode', 'memberName', 'memberEmail', 'destinationWalletId', 'destinationWalletLabel', 'destinationAddressSnapshot', 'destinationExplorerUrl', 'displaySymbol', 'expectedCurrency', 'walletAddress', 'txHash', 'failureReason', 'mismatchReason', 'operatorReviewNote'].every(key => nullableText(intent[key]))
  && typeof intent.memberNote === 'string'
  && Number.isFinite(intent.expectedAmount) && intent.expectedAmount >= 0
  && nullableAmount(intent.suggestedAmount) && nullableAmount(intent.observedAmount)
  && statuses.includes(intent.status)
  && Number.isInteger(intent.paymentWindowMinutes) && intent.paymentWindowMinutes > 0
  && ['expiresAt', 'createdAt', 'updatedAt'].every(key => requiredDate(intent[key]))
  && ['submittedAt', 'observedAt', 'verifiedAt', 'operatorReviewedAt'].every(key => date(intent[key]))
  && ['unreviewed', 'reviewed', 'resolved'].includes(intent.operatorReviewStatus)
  && (intent.operatorReviewedBy === null || isRecord(intent.operatorReviewedBy) && safe(intent.operatorReviewedBy)
    && text(intent.operatorReviewedBy.id) && nullableText(intent.operatorReviewedBy.name) && nullableText(intent.operatorReviewedBy.email))
  && isRecord(intent.metadata);

const fail = (operation, detail) => { throw new TreasuryPaymentIntentResponseContractError(operation, detail); };

export const readTreasuryPaymentIntentListResponse = payload => {
  if (!isRecord(payload) || payload.success !== true || !Array.isArray(payload.data) || !payload.data.every(isPaymentIntent)) {
    fail('list', 'expected the permission-filtered payment-intent list and complete records.');
  }
  return payload;
};

export const readTreasuryPaymentIntentResponse = payload => {
  if (!isRecord(payload) || payload.success !== true || !isPaymentIntent(payload.data)) {
    fail('detail', 'expected the permission-filtered payment-intent record.');
  }
  return payload;
};
